import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { AssetUrlPipe } from "./asset-url.pipe";
import { ASSET_ROOT_URL } from "./asset-url.providers";

@NgModule({
  declarations: [AssetUrlPipe],
  exports: [AssetUrlPipe],
  imports: [CommonModule]
})
export class AssetUrlModule {
  static forRoot(assetRootUrl: string): ModuleWithProviders<AssetUrlModule> {
    return {
      ngModule: AssetUrlModule,
      providers: [{ provide: ASSET_ROOT_URL, useValue: assetRootUrl }]
    };
  }
}
